// extracted by mini-css-extract-plugin
export default {"linkButton":"Xz3HmSACWt92MADLPYwx","footerRow":"l9uAPArY7U6KaJYwqqg1","footerLinksRow":"C2Qub08sFb8thI13kzkD","footerText":"_mg9HsbSiRaFkkOIvwDG"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"linkButton\":\"Xz3HmSACWt92MADLPYwx\",\"footerRow\":\"l9uAPArY7U6KaJYwqqg1\",\"footerLinksRow\":\"C2Qub08sFb8thI13kzkD\",\"footerText\":\"_mg9HsbSiRaFkkOIvwDG\"}";
        // 1741856396339
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  